
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tramos",
      function () {
        return require("private-next-pages/tramos/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tramos"])
      });
    }
  